import { ImageStock, MockupDesign, ThreeDModels, Uidesign } from "../images";

export const categoriesSwiperSvg: {
  title: string;
  svgImg: JSX.Element;
  items: number;
}[] = [
  {
    title: "WordPress Themes",
    svgImg: (
      <svg
        width={"56px"}
        height={"56px"}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="#d5d5ff"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 56 56"
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill:none;stroke:#191919;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#191919;stroke-width:2;}\n",
          }}
        />
        <path d="M28,0L28,0c15.5,0,28,12.5,28,28l0,0c0,15.5-12.5,28-28,28l0,0C12.5,56,0,43.5,0,28l0,0C0,12.5,12.5,0,28,0z" />
        <path className="st0" d="M29.5,31.4v11.9l3.5-6l3.5,6V31.4" />
        <path className="st0" d="M41.4,43.3V31.4" />
        <path
          className="st0"
          d="M41.4,31.4h1.1c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.7-3.5,3.7h-1.1"
        />
        <path
          className="st0"
          d="M44,25.5V21 M12,21v20.7c0,1.2,1.1,2.3,2.3,2.3h9.4"
        />
        <path
          className="st1"
          d="M12,15c0-1.1,0.9-2,2-2h28c1.1,0,2,0.9,2,2v5H12V15z"
        />
      </svg>
    ),
    items: 5,
  },
  {
    title: "eCommerce Templates",
    svgImg: (
      <svg
        width={"56px"}
        height={"56px"}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="#ffd6b0"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 56 56"
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;stroke:#191919;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#191919;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{stroke:#191919;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n",
          }}
        />
        <path d="M28,0L28,0c15.5,0,28,12.5,28,28l0,0c0,15.5-12.5,28-28,28l0,0C12.5,56,0,43.5,0,28l0,0C0,12.5,12.5,0,28,0z" />
        <path
          className="st0"
          d="M37.7,32.9H18.1c-2.2,0-4.2-1.5-4.7-3.7L11,19.8c-0.1-0.4,0-0.8,0.2-1c0.2-0.3,0.6-0.5,1-0.5h28"
        />
        <path
          className="st1"
          d="M37.7,32.9H18.1c-2.2,0-4.2-1.5-4.7-3.7L11,19.8c-0.1-0.4,0-0.8,0.2-1c0.2-0.3,0.6-0.5,1-0.5h28L37.7,32.9z"
        />
        <path
          className="st2"
          d="M18.3,40.2h16.1c1.2,0,2.2-0.9,2.4-2L41,13c0.2-1.2,1.2-2,2.4-2H45"
        />
        <path
          className="st3"
          d="M21.3,43.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6C20.7,44.1,21,43.8,21.3,43.8"
        />
        <path
          className="st3"
          d="M33.5,43.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6C32.9,44.1,33.1,43.8,33.5,43.8  "
        />
        <path className="st3" d="M18.3,23.1v3.7" />
        <path className="st3" d="M25.6,23.1v3.7" />
        <path className="st3" d="M32.9,23.1v3.7" />
      </svg>
    ),
    items: 15,
  },
  {
    title: "Site Templates",
    svgImg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#beebf6"
        width={56}
        height={56}
        viewBox="0 0 56 56"
      >
        <rect width={56} height={56} rx={28} fill="inherit" />
        <path
          d="M11 14.3915C11 13.116 12.1363 12 13.435 12H42.655C43.9537 12 45.09 13.116 45.09 14.3915V40.6982C45.09 41.9737 43.9537 43.0897 42.655 43.0897H13.435C12.1363 43.0897 11 41.9737 11 40.6982V14.3915Z"
          fill="white"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M11 19.1746H45.09H11Z" fill="white" />
        <path
          d="M11 19.1746H45.09"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8701 25.233C15.8701 24.5952 16.3571 23.9575 17.1688 23.9575H38.9214C39.5708 23.9575 40.2201 24.4358 40.2201 25.233V27.6245C40.2201 28.2622 39.7331 28.9 38.9214 28.9H17.0064C16.3571 28.9 15.7078 28.4217 15.7078 27.6245V25.233H15.8701Z"
          fill="white"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8692 34.7992C15.8692 34.1614 16.3562 33.5237 17.1679 33.5237H22.0379C22.6872 33.5237 23.3366 34.002 23.3366 34.7992V37.1907C23.3366 37.8284 22.8496 38.4662 22.0379 38.4662H17.1679C16.5186 38.4662 15.8692 37.9878 15.8692 37.1907V34.7992Z"
          fill="white"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M27.8831 33.5237H40.0581H27.8831Z" fill="white" />
        <path
          d="M27.8831 33.5237H40.0581"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M27.8831 38.3068H40.0581H27.8831Z" fill="white" />
        <path
          d="M27.8831 38.3068H40.0581"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    items: 35,
  },
  {
    title: "Marketing Templates",
    svgImg: (
      <svg
        width={56}
        height={56}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="#fff48a"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 56 56"
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill:#FFFFFF;stroke:#191919;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{stroke:#191919;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;}\n",
          }}
        />
        <path d="M28,0L28,0c15.5,0,28,12.5,28,28l0,0c0,15.5-12.5,28-28,28l0,0C12.5,56,0,43.5,0,28l0,0C0,12.5,12.5,0,28,0z" />
        <path
          className="st0"
          d="M47.7,32.3c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.5l-1.6-4.3l0.6-1.7l0.9-2.5c0.2-0.6,0-1.4-0.6-1.7l-4-2.5  l-1.3-4.4c-0.2-0.6-0.8-1.1-1.4-1.1l-4.6,0.2l-3.6-2.8c-0.6-0.5-1.4-0.5-1.9,0l-3.6,2.8L22.1,13l0,0l0,0c-0.6,0-1.3,0.5-1.4,1.1  l-1.3,4.4l-4,2.5c-0.2,0.1-0.4,0.3-0.5,0.5c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2s-0.1,0.3-0.1,0.4c0,0.2,0,0.3,0.1,0.5l1.6,4.3  l-0.6,1.7l-0.9,2.5c-0.2,0.6,0,1.4,0.6,1.7l4,2.5l1.3,4.4c0.2,0.6,0.8,1.1,1.4,1.1l4.6-0.2l3.6,2.8c0.6,0.5,1.4,0.5,1.9,0l3.6-2.8  l4.5,0.2l0,0l0,0c0.6,0,1.3-0.5,1.4-1.1l1.3-4.4l4-2.5c0.2-0.1,0.4-0.3,0.5-0.5c0,0,0-0.1,0.1-0.1C47.7,32.4,47.7,32.4,47.7,32.3z"
        />
        <path className="st1" d="M9.4,40.1l2.7,4.1" />
        <path className="st2" d="M24.4,21.6l10,15.7L24.4,21.6z" />
        <path className="st1" d="M24.4,21.6l10,15.7" />
        <path
          className="st1"
          d="M16.3,41.8l1.4,2.1c0.5,0.8,1.3,1.3,2.1,1.4c0.8,0.2,1.7,0,2.5-0.5c1.6-1.1,1.9-3.2,0.9-4.7L23,39.8"
        />
        <path
          className="st0"
          d="M33.4,36.5l-21.8,7L10,40.9l14.6-18.3L33.4,36.5z"
        />
      </svg>
    ),
    items: 65,
  },
  {
    title: "CMS Templates",
    svgImg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#d2fae6"
        width={56}
        height={56}
        viewBox="0 0 56 56"
      >
        <rect width={56} height={56} rx={28} fill="inherit" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 13.2667C11 12.0155 12.0155 11 13.2667 11H42.7333C43.9845 11 45 12.0155 45 13.2667V42.7333C45 43.9845 43.9845 45 42.7333 45H13.2667C12.0155 45 11 43.9845 11 42.7333V13.2667Z"
          fill="white"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2667 30.2668H39.3333H30.2667Z"
          fill="white"
        />
        <path
          d="M30.2667 30.2668H39.3333"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2667 34.8002H39.3333H30.2667Z"
          fill="white"
        />
        <path
          d="M30.2667 34.8002H39.3333"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2667 39.3335H35.9333H30.2667Z"
          fill="white"
        />
        <path
          d="M30.2667 39.3335H35.9333"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5333 30.2668H24.6H15.5333Z"
          fill="white"
        />
        <path
          d="M15.5333 30.2668H24.6"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5333 34.8002H24.6H15.5333Z"
          fill="white"
        />
        <path
          d="M15.5333 34.8002H24.6"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5333 39.3335H21.2H15.5333Z"
          fill="white"
        />
        <path
          d="M15.5333 39.3335H21.2"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5333 16.6667C15.5333 16.0411 16.0411 15.5333 16.6667 15.5333H39.3333C39.9589 15.5333 40.4667 16.0411 40.4667 16.6667V23.4667C40.4667 24.0923 39.9589 24.6 39.3333 24.6H16.6667C16.0411 24.6 15.5333 24.0923 15.5333 23.4667V16.6667Z"
          fill="white"
          stroke="#191919"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    items: 83,
  },
  {
    title: "Blogging",
    svgImg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#d5d5ff"
        width={56}
        height={56}
        viewBox="0 0 56 56"
      >
        <rect width={56} height={56} rx={28} fill="inherit" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.7393 17.913H44.348Z"
          fill="white"
        />
        <path
          d="M29.7393 17.913H44.348"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.7393 11.6522H44.348Z"
          fill="white"
        />
        <path
          d="M29.7393 11.6522H44.348"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.7393 24.1739H44.348Z"
          fill="white"
        />
        <path
          d="M29.7393 24.1739H44.348"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9565 31.1305H45.0435Z"
          fill="white"
        />
        <path
          d="M10.9565 31.1305H45.0435"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9565 37.3913H45.0435Z"
          fill="white"
        />
        <path
          d="M10.9565 37.3913H45.0435"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9565 44.3479H36Z"
          fill="white"
        />
        <path
          d="M10.9565 44.3479H36"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9565 13.9466C10.9565 12.6801 11.9419 11.6522 13.1594 11.6522H21.971C23.187 11.6522 24.1739 12.6801 24.1739 13.9466V22.5752C24.1739 23.8417 23.187 24.8696 21.971 24.8696H13.1594C11.9419 24.8696 10.9565 23.8417 10.9565 22.5752V13.9466Z"
          fill="white"
          stroke="black"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    items: 21,
  },
];

export const categoriesSwiperImg: {
  title: string;
  img: JSX.Element;
  items: number;
}[] = [
  {
    title: "UI Design",
    img: <img src={`${Uidesign}`} alt="Uidesign" width={56} height={56} />,
    items: 50,
  },
  {
    title: "3D Models",
    img: <img src={`${ThreeDModels}`} alt="3d-models" width={56} height={56} />,
    items: 5,
  },
  {
    title: "Image Stock",
    img: <img src={`${ImageStock}`} alt="ImageStock" width={56} height={56} />,
    items: 62,
  },
  {
    title: "Mockup Design",
    img: (
      <img src={`${MockupDesign}`} alt="MockupDesign" width={56} height={56} />
    ),
    items: 77,
  },
];
